import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollbarRouteClass() {
  const { pathname } = useLocation();

  useEffect(() => {
    const el = document.documentElement; // same target you used before

    const enabled = pathname.startsWith("/storymap");
    el.classList.toggle("autohide-mobile-scrollbar", enabled);

    if (!enabled) return;

    let timer: number | undefined;

    const onScroll = () => {
      el.classList.add("scrolling");
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        el.classList.remove("scrolling");
      }, 700); // feels close to YouTube mobile
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      el.classList.remove("autohide-mobile-scrollbar", "scrolling");
      window.clearTimeout(timer);
    };
  }, [pathname]);

  return null;
}